<template>
  <div class="ml-2 mr-4 pb-3">
    <validation-observer ref="rejectRef" v-slot="{}" tag="form">
      <div class="row mt-3">
        <div class="col col-sm col-12 pt-2">
          <em class="fas fa-times-circle text-orange mr-1" />
          <span class="color-gray-7 font-16 font-weight-bold">
            {{ title || 'Razón de Rechazo' }}
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-5 mb-4">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-drop-down
              v-model="reason"
              custom-error-msg="La razón de denegación es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Razón de Denegación:"
              :options="reasonList"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <span class="color-gray-6 d-block font-14 mb-2">Comentario:</span>
          <span class="font-16 color-black">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="comment"
                :count-classes="['float-right']"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
          </span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <action-button
            class="float-right ml-2"
            i="fas fa-save fa-lg"
            text="Guardar"
            variant="success mt-3"
            @click="onSave"
          />
          <action-button
            class="float-right"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mb-4 mt-3"
            @click="onCancel"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

import { changeRequestStatus } from '@/services/provider/compensatoryRequest.api';
import { getCompletePendingApprovalDenialReasons as getDenialReasons } from '@/services/provider/compensatoryRequest.api';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'DenyRequest',
  components: {
    CustomDropDown,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    submitStatusId: {
      type: Number,
      required: false,
    },
  },
  data: () => ({
    comment: null,
    reason: null,
    reasonList: [],
  }),
  async mounted() {
    await getDenialReasons().then((resp) => (this.reasonList = resp.data));
  },
  methods: {
    onCancel() {
      this.comment = null;
      this.reason = null;
      this.$emit('on-cancel');
    },
    async onSave() {
      const isValid = await this.$refs.rejectRef.validate();
      if (isValid) {
        let payload = {
          requestId: this.value.requestId,
          statusId:
            this.submitStatusId == undefined
              ? compensatoryRequestStatus.Denegado
              : this.submitStatusId,
          comment: this.comment,
          reasonId: this.reason.id,
        };

        await changeRequestStatus(payload)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'La solicitud ha sido rechazada exitosamente.',
              'success'
            );
            this.$emit('on-save');
          })
          .catch(() =>
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
          );
      }
    },
  },
};
</script>
